import { Navigate } from 'react-router-dom';
import { PrivateRouting } from '../models/global';

const PrivateRoute = ({ isLoggedIn, children, isForAdmin, isAdmin }: PrivateRouting) => {
  if (!isLoggedIn) {
    return <Navigate to='/login' state={{ from: window.location.pathname }} />;
  }
  if (isForAdmin && !isAdmin) {
    return <Navigate to='/' />;
  }
  return children;
};
export default PrivateRoute;
